import { memo, useCallback } from 'react';

import styles from './SearchKnmPanelFilters.module.scss';

interface IKnmSearchFilterDatesProps {
  fromDate: string;
  toDate: string;
  removeFilterValue: (title: string) => void;
}

export const KnmSearchFilterDates = memo(({ fromDate, toDate, removeFilterValue }: IKnmSearchFilterDatesProps) => {
  const onRemove = useCallback(() => {
    removeFilterValue('fromDate');
    removeFilterValue('toDate');
  }, [removeFilterValue]);

  return (
    <div className={styles.FilterWrap}>
      <div className={styles.FilterLabel}>Период проведения</div>
      <div className={styles.FilterTextWrap}>
        <div className={styles.FilterText}>{`${fromDate} - ${toDate}`}</div>
        <div className={styles.FilterRemove} onClick={onRemove} />
      </div>
    </div>
  );
});
